import { render, staticRenderFns } from "./PageStatsTable.vue?vue&type=template&id=54fbbf40&scoped=true&"
import script from "./PageStatsTable.vue?vue&type=script&lang=js&"
export * from "./PageStatsTable.vue?vue&type=script&lang=js&"
import style0 from "./PageStatsTable.vue?vue&type=style&index=0&id=54fbbf40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fbbf40",
  null
  
)

export default component.exports